import { useQuery } from '@tanstack/react-query'

import { useMockEnvironment } from '@contexts/mockEnv'
import { mockedPermitTypes } from '@hooks/mocks/permitTypes'
import { useFindProfile } from '@hooks/profile'
import { api } from '@services/apiClient'

interface IPermitType {
  description: string
  isActive: boolean
  id: number
}

export const useFindPermits = () => {
  const { isMockEnvironment } = useMockEnvironment()

  const { data: user } = useFindProfile()
  const siteId = user && user.selectedSite.id

  async function fetchPermits() {
    if (!isMockEnvironment) {
      const { data } = await api.get<IPermitType[]>(
        `sites/${siteId}/permitTypes`,
      )
      return data
    }
    return mockedPermitTypes
  }

  return useQuery({ queryKey: ['PERMIT_TYPES'], queryFn: fetchPermits })
}
